import { Injectable } from "@angular/core";
import { AuthService } from "@core/auth";
import { BehaviorSubject, Observable, Subscription, catchError, of, switchMap, tap, timer } from "rxjs";
import { CurrentConsultationResponse } from "./consultations.model";
import { ConsultationsService } from "./consultations.service";

@Injectable({
    providedIn: "root",
})
export class ActiveConsultationStateService {
    private activeConsultationSubject = new BehaviorSubject<CurrentConsultationResponse | null>(null);
    private pollingSubscription?: Subscription;

    activeConsultation$ = this.activeConsultationSubject.asObservable();

    constructor(private consultationsService: ConsultationsService, private authService: AuthService) {
        this.authService.hasAuthentication().subscribe((authenticated) => {
            if (authenticated) this.startPolling();
            else this.stopPolling();
        });
    }

    startPolling(intervalMs = 10000) {
        if (this.pollingSubscription || !this.authService.token) return;

        this.pollingSubscription = timer(0, intervalMs).pipe(
            switchMap(() => this.fetchCurrentConsultation()),
        ).subscribe();
    }

    stopPolling() {
        this.pollingSubscription?.unsubscribe();
        this.pollingSubscription = undefined;
        this.activeConsultationSubject.next(null);
    }

    refresh(): Observable<CurrentConsultationResponse | null> {
        return this.fetchCurrentConsultation();
    }

    private fetchCurrentConsultation() {
        return this.consultationsService.getCurrentConsultation().pipe(
            catchError(() => of(null)),
            tap((consultation) => this.activeConsultationSubject.next(consultation)),
        );
    }
}
